export const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;
export const CRYPTO_KEY = process.env.REACT_APP_CRYPTO_KEY;

export const CHANNEL_SECRET_KEY = process.env.REACT_APP_CHANNEL_SECRET_KEY;
export const DSN_KEY = process.env.REACT_APP_DSN_KEY;
export const FUSIONCHARTS_KEY = process.env.REACT_APP_FUSIONCHARTS_KEY;
export const TOSS_CLIENT_KEY = process.env.REACT_APP_TOSS_CLIENT_KEY;
